import { useCallback, useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import styled from "styled-components";

export default function useDialog(options = undefined) {
    const { Component = StyledDialog } = options ?? {};

    const [isOpen, setIsOpen] = useState(false);

    function open() {
        setIsOpen(true);
    }

    function close() {
        setIsOpen(false);
    }

    const Dialog = useCallback(
        function Dialog(props) {
            const ref = useRef<HTMLDialogElement>();

            useEffect(
                () => {
                    if (ref.current && isOpen) {
                        ref.current.showModal();
                    }

                    return () => {
                        ref.current?.close();
                    };
                },
                [isOpen],
            );

            useEffect(
                () => {
                    if (!ref.current) return;

                    ref.current.addEventListener(
                        "cancel",
                        () => setIsOpen(false),
                    );
                },
                [],
            );

            if (!isOpen) return undefined;

            function x(event) {
                function inRect(box: DOMRect, x: number, y: number) {
                    return [
                        box.top <= y,
                        y <= box.top + box.height,
                        box.left <= x,
                        x <= box.left + box.width,
                    ].every(Boolean);
                }

                const inDialog = inRect(
                    ref.current.getBoundingClientRect(),
                    event.clientX,
                    event.clientY,
                );

                const isLast = Array.from(document.querySelectorAll("dialog")).pop() === ref.current;

                if (!inDialog && isLast) {
                    close();
                }
            }

            return (
                <Component ref={ ref } onClick={ x } className={ props.className }>
                    <CloseBait className="close" onClick={ close } />
                    { props.children }
                </Component>
            );
        },
        [isOpen],
    );

    return [
        Dialog,
        open,
        close,
    ] as const;
}

const StyledDialog = styled.dialog`
    border: none;
    bottom: 0;
    box-sizing: border-box;
    height: 100%;
    left: 50%;
    margin: 0;
    max-height: unset;
    position: fixed;
    top: 0;
    width: 50%;

    &::backdrop {
        background: #0007;
    }

    body:has(&[open]) {
        overflow: hidden;
    }
`;

const CloseBait = styled(IoClose)`
    color: #fff;
    cursor: pointer;
    font-size: 2.4rem;
    position: fixed;
    right: calc(50% + 16px);

    &:hover {
        opacity: .8;
    }
`;
